import React, { useEffect, useState } from 'react';
import { SectionGuide } from '../../components/pas/SectionGuide';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ArrowLeft, FileText } from 'lucide-react';
import { usePASClientAuth } from '../../context/PASClientAuthContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const label = (t) => t.replace(/_/g, ' ');

export default function TaxForms() {
  const navigate = useNavigate();
  const { pasClient, token, loading } = usePASClientAuth();
  const [forms, setForms] = useState(null);
  const [year, setYear] = useState('all');

  useEffect(() => { if (!loading && !pasClient) navigate('/pas/login'); }, [loading, pasClient, navigate]);
  useEffect(() => {
    if (token) axios.get(`${API}/pas-tax/8824`, { headers: { Authorization: `Bearer ${token}` } }).then(r => setForms(r.data.forms)).catch(() => setForms([]));
  }, [token]);

  const years = [...new Set((forms || []).map(f => f.tax_year))];
  const shown = (forms || []).filter(f => year === 'all' || f.tax_year === year);

  return (
    <div className="min-h-screen bg-slate-900">
      <header className="bg-slate-800 border-b border-slate-700">
        <div className="max-w-5xl mx-auto px-4 py-4 flex items-center gap-4">
          <button onClick={() => navigate('/pas/dashboard')} className="p-2 text-slate-400 hover:text-white" data-testid="tax-forms-back-btn"><ArrowLeft className="w-5 h-5" /></button>
          <div>
            <h1 className="text-lg font-bold text-white">IRS Form 8824 - Like-Kind Exchanges</h1>
            <p className="text-xs text-slate-400">One pre-filled form for every BETH transaction on your account</p>
          </div>
        </div>
      </header>
      <main className="max-w-5xl mx-auto px-4 py-8">
        <SectionGuide id="tax-forms" className="mb-6" />
        <div className="flex gap-2 mb-4">
          {['all', ...years].map(y => (
            <button key={y} onClick={() => setYear(y)} data-testid={`tax-year-${y}`}
              className={`px-3 py-1.5 rounded-lg text-sm ${year === y ? 'bg-emerald-500 text-white' : 'bg-slate-800 text-slate-300'}`}>{y === 'all' ? 'All years' : y}</button>
          ))}
        </div>
        <div className="bg-slate-800 border border-slate-700 rounded-xl divide-y divide-slate-700" data-testid="tax-forms-list">
          {forms === null && <p className="p-6 text-slate-400">Loading...</p>}
          {forms && shown.length === 0 && <p className="p-6 text-slate-500">No transactions yet</p>}
          {shown.map(f => (
            <button key={f.transaction_id} onClick={() => navigate(`/pas/tax-forms/${f.transaction_id}`)} data-testid={`tax-form-row-${f.transaction_id}`}
              className="w-full flex items-center justify-between px-5 py-4 hover:bg-slate-700/50 text-left">
              <div className="flex items-center gap-3">
                <FileText className="w-5 h-5 text-emerald-400" />
                <div>
                  <p className="text-white capitalize">{label(f.type)} {f.check_number && <span className="text-slate-400 text-sm font-mono">#{f.check_number}</span>}</p>
                  <p className="text-xs text-slate-500">{new Date(f.created_at).toLocaleDateString()} &middot; property {f.direction}{f.customer_edited ? ' · edited by you' : ''}</p>
                </div>
              </div>
              <div className="text-right">
                <p className="text-white">{f.beth_amount.toLocaleString()} BETH</p>
                <p className="text-xs text-slate-400">${f.usd_value.toLocaleString(undefined, { minimumFractionDigits: 2 })}</p>
              </div>
            </button>
          ))}
        </div>
      </main>
    </div>
  );
}
